import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'


class VideoComponent extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (

        
            <video autoPlay muted loop id="myVideo">
                <source src="videos/telematics_background_video.mp4" type="video/mp4"></source>
                    Your browser does not support HTML5 video.
            </video>
        );
    }
}

export default VideoComponent;